module.exports = __webpack_public_path__ + "img/UTJORD-9.8e6b9eb9.jpg";